'use client';

import "core-js/modules/esnext.string.replace-all.js";
import { jsxs, jsx } from 'react/jsx-runtime';
import { MantineProvider } from '@mantine/core';
import { advisaTheme } from '../themes/advisa.mjs';
import { samblaTheme } from '../themes/sambla.mjs';
import { omalainaTheme } from '../themes/omalaina.mjs';
import { rahalaitosTheme } from '../themes/rahalaitos.mjs';
import { digifinansTheme } from '../themes/digifinans.mjs';
import { samblaGroupTheme } from '../themes/samblaGroup.mjs';
import { rahoituTheme } from '../themes/rahoitu.mjs';
var brandMap = new Map([["Sambla", advisaTheme], ["Advisa", samblaTheme], ["Omalaina", omalainaTheme], ["Rahalaitos", rahalaitosTheme], ["Digifinans", digifinansTheme], ["Rahoitu", rahoituTheme], ["Sambla Group", samblaGroupTheme]]);
var DynamicCSS = function DynamicCSS(_ref) {
  var brand = _ref.brand;
  brand = brand.trim();
  brand = brand.replaceAll("-", " ");
  brand = brand.split(" ").map(function (word) {
    return word.charAt(0).toUpperCase() + word.slice(1);
  }).join(" ");
  switch (brand) {
    case "Sambla":
      import('../tokens/build/css/sambla/tokens.css.mjs');
      import('../tokens/build/css/sambla/fonts.css.mjs');
      break;
    case "Advisa":
      import('../tokens/build/css/advisa/tokens.css.mjs');
      import('../tokens/build/css/advisa/fonts.css.mjs');
      break;
    case "Omalaina":
      import('../tokens/build/css/omalaina/tokens.css.mjs');
      import('../tokens/build/css/omalaina/fonts.css.mjs');
      break;
    case "Rahalaitos":
      import('../tokens/build/css/rahalaitos/tokens.css.mjs');
      import('../tokens/build/css/rahalaitos/fonts.css.mjs');
      break;
    case "Digifinans":
      import('../tokens/build/css/digifinans/tokens.css.mjs');
      import('../tokens/build/css/digifinans/fonts.css.mjs');
      break;
    case "Rahoitu":
      import('../tokens/build/css/rahoitu/tokens.css.mjs');
      import('../tokens/build/css/rahoitu/fonts.css.mjs');
      break;
    case "Sambla Group":
      import('../tokens/build/css/samblagroup/tokens.css.mjs');
      import('../tokens/build/css/samblagroup/fonts.css.mjs');
      break;
    default:
      throw new Error("Invalid brand");
  }
  import('../tokens/build/css/custom-components.css.mjs');
  return null;
};
var WalletProvider = function WalletProvider(props) {
  return jsxs(MantineProvider, {
    theme: brandMap.get(props.brand),
    children: [jsx(DynamicCSS, {
      brand: props.brand
    }), props.children]
  });
};
export { WalletProvider as default };